import { useQuery } from "@tanstack/react-query";
import { Status as UserStatus } from "entities/users/types";
import getUsersCountByStatuses from "../api/getUsersCountByStatuses";

type PropsQuery = {
  usersStatuses: UserStatus[];
};

export const useUsersCountByStatuses = ({ usersStatuses }: PropsQuery) => {
  return useQuery({
    queryKey: ["userStatusCount", usersStatuses],
    queryFn: async () => await getUsersCountByStatuses(usersStatuses),
  });
};
